import axiosClient from "../axiosClient";
import API_MAP from "../../constants/api";

class ApiManagerEvent {
    search = (data) => {
        let _data = data
        _data.displayModule = data?.displayModule.filter( r => r)
        _data.eventStatus = ((data.status)?.length === 2) ? '' : (data.status?.[0] === 'locked' ? 0 : 1)
        return axiosClient.post(API_MAP.GET_LIST_EVENT, _data)
    }

    getListEvent = (data) => {
        return axiosClient.post(API_MAP.GET_LIST_EVENT, data)
    }
    getListEventAdmin = () => {
        return axiosClient.get(API_MAP.GET_LIST_EVENT_ADMIN_ACTIVE)
    }
    
    create = (data) => {
        return axiosClient.post(API_MAP.CREATE_EVENT, data)
    }
    getById = (id) => {
        return axiosClient.get(API_MAP.GET_DETAIL_EVENT + "/" + id)
    }
    update = (id, data) => {
        return axiosClient.post(API_MAP.UPDATE_EVENT + "/" + id, data)
    }
    delete = (data) => {
        return axiosClient.post(API_MAP.DELETE_EVENT + "/" + data.id)
    }
    updateStatusEventApi = (data) => {
        return axiosClient.post(API_MAP.UPDATE_STATUS_EVENT + "/" + data.id, data)
    }
}

const apiManagerEvent = new ApiManagerEvent();

export default apiManagerEvent;